import { PropTypes } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { compose } from 'redux';

const messages = defineMessages({
  mostSearchedTerms: {
    id: 'Most searched terms',
    defaultMessage: 'MOST SEARCHED TERMS',
  },
});

const TermsList = ({ terms, nTerms, className, intl }) => (
  <div className={`br-list most-searched-terms ${className}`}>
    <div className="br-item text-weight-medium pt-3" role="listitem">
      {intl.formatMessage(messages.mostSearchedTerms)}
    </div>
    {terms.slice(0, nTerms).map((term) => (
      <Link
        key={term}
        to={`/search?origem=termos&SearchableText=${encodeURIComponent(term)}`}
        className="br-item"
        role="listitem"
      >
        <span className="row align-items-center">
          <span className="col-auto">
            <i className="fa-solid fa-arrow-trend-up" aria-hidden="true"></i>
          </span>
          <span className="col">{term}</span>
        </span>
      </Link>
    ))}
  </div>
);

TermsList.propTypes = {
  terms: PropTypes.array.isRequired,
  nTerms: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
};

export default compose(injectIntl)(TermsList);
